// Sign-in gate. Uses Google Identity Services (@react-oauth/google's
// GoogleLogin one-tap-style button) to obtain an ID token, then hands it to
// the AuthProvider. Restricted to @curvedental.com domain server-side.

import { GoogleLogin } from '@react-oauth/google'
import { useAuth } from '../lib/auth'

const ALLOWED_DOMAIN = 'curvedental.com'

export function SignIn() {
  const { signIn } = useAuth()

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-marker-bg p-6">
      <div className="w-full max-w-md bg-marker-panel rounded-lg border border-marker-border p-8">
        <div className="text-center mb-6">
          <div className="text-3xl font-semibold mb-2 text-marker-text">Marker</div>
          <div className="text-sm text-marker-muted">
            Curve Dental competitive intelligence
          </div>
        </div>

        <div className="mb-6 text-sm text-marker-text leading-relaxed">
          Ask questions about our Gong call data, Salesforce opportunities,
          and competitive intel in plain English. Every answer cites the
          data it came from.
        </div>

        <div className="flex justify-center">
          <GoogleLogin
            onSuccess={(res) => {
              if (res.credential) {
                signIn(res.credential)
              }
            }}
            onError={() => {
              alert('Sign-in failed. Please try again.')
            }}
            theme="filled_black"
            size="large"
            text="continue_with"
            shape="pill"
            useOneTap
          />
        </div>

        <div className="mt-6 text-xs text-marker-muted text-center">
          Restricted to @{ALLOWED_DOMAIN} accounts.
        </div>
      </div>

      <div className="mt-6 text-xs text-marker-muted">
        Built by Sales Ops · Marker v0
      </div>
    </div>
  )
}
